import { Container, Row, Col } from "react-bootstrap";

const LoginMobile = ({ handleSubmit, email, setEmail, status }) => {
    const inputStyle = {
        width: '100%',
        height: "50px",
        border: "2px solid #e2e8f0",
        outline: "none",
        color: "#1a1a2e",
        backgroundColor: "#ffffff",
        borderRadius: "10px",
        paddingLeft: "16px",
        paddingRight: "16px",
        fontSize: "1rem",
        transition: "border-color 0.2s, box-shadow 0.2s"
    };

    return (
        <>
            {/* Dark Header */}
            <div style={{
                background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)',
                padding: '80px 0 3rem'
            }}>
                <Container>
                    <Row className="justify-content-center">
                        <Col xs={11} className="text-center">
                            <h1 style={{
                                color: 'white',
                                fontWeight: '700',
                                fontSize: '1.75rem',
                                marginBottom: '0.5rem'
                            }}>
                                Welcome Back
                            </h1>
                            <p style={{
                                color: 'rgba(255, 255, 255, 0.7)',
                                fontSize: '1rem',
                                margin: 0
                            }}>
                                Sign in to access your dashboard
                            </p>
                        </Col>
                    </Row>
                </Container>
            </div>

            {/* Login Form */}
            <Container style={{ marginTop: '-1.5rem', paddingBottom: '2rem' }}>
                <Row className="justify-content-center">
                    <Col xs={11}>
                        <div style={{
                            background: 'white',
                            borderRadius: '16px',
                            padding: '1.5rem',
                            boxShadow: '0 4px 24px rgba(0,0,0,0.08)'
                        }}>
                            {/* Google Sign In */}
                            <button
                                type="button"
                                onClick={() => window.location.href = '/auth/google'}
                                style={{
                                    width: '100%',
                                    height: '50px',
                                    backgroundColor: '#ffffff',
                                    color: '#1a1a2e',
                                    border: '2px solid #e2e8f0',
                                    borderRadius: '10px',
                                    fontWeight: '500',
                                    fontSize: '0.95rem',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    cursor: 'pointer'
                                }}
                            >
                                <img
                                    src="https://developers.google.com/identity/images/g-logo.png"
                                    alt="Google logo"
                                    style={{ width: '20px', height: '20px', marginRight: '10px' }}
                                />
                                Sign in with Google
                            </button>

                            {/* Divider */}
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                margin: '1.25rem 0'
                            }}>
                                <hr style={{ flex: 1, border: 'none', borderTop: '1px solid #e2e8f0' }} />
                                <span style={{ margin: '0 0.75rem', color: '#94a3b8', fontSize: '0.8rem' }}>or use email</span>
                                <hr style={{ flex: 1, border: 'none', borderTop: '1px solid #e2e8f0' }} />
                            </div>

                            {/* Email Form */}
                            <form onSubmit={handleSubmit}>
                                <div style={{ marginBottom: '1rem' }}>
                                    <input
                                        type="email"
                                        id="email"
                                        name="email"
                                        placeholder="Enter your email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        required
                                        style={inputStyle}
                                    />
                                </div>
                                <button
                                    type="submit"
                                    style={{
                                        width: '100%',
                                        height: '50px',
                                        background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
                                        color: 'white',
                                        border: 'none',
                                        borderRadius: '10px',
                                        fontWeight: '600',
                                        fontSize: '1rem',
                                        cursor: 'pointer'
                                    }}
                                >
                                    Send Login Code
                                </button>
                                {status && (
                                    <p style={{
                                        marginTop: '1rem',
                                        color: status.includes('wrong') ? '#ef4444' : '#64748b',
                                        textAlign: 'center',
                                        fontSize: '0.875rem'
                                    }}>
                                        {status}
                                    </p>
                                )}
                            </form>

                            <p style={{
                                marginTop: '1.25rem',
                                textAlign: 'center',
                                color: '#94a3b8',
                                fontSize: '0.75rem'
                            }}>
                                We'll send you a 6-digit code to sign in.
                            </p>
                        </div>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default LoginMobile;
